/* eslint-disable react/no-danger */
import React from 'react';
import { Flex, Skeleton } from '@patternfly/react-core';
import { useTranslation } from 'react-i18next';

import { LandingLayout } from 'components/Landing/LandingLayout';
import type { LearningPath } from 'types';

import './styles.scss';

interface OverviewTabProps {
  learningPath: LearningPath | null;
  isLoading?: boolean;
}

const OverviewTabSkeleton: React.FC = () => (
  <Flex
    data-testid="overview-tab-skeleton"
    direction={{ default: 'column' }}
    gap={{ default: 'gapMd' }}
    style={{ paddingTop: 'var(--pf-v5-global--spacer--md)' }}
  >
    <LandingLayout.Progress>
      <Flex justifyContent={{ default: 'justifyContentFlexEnd' }}>
        <Skeleton width="80px" height="24px" />
      </Flex>
    </LandingLayout.Progress>
    <Skeleton width="100%" height="60px" />
    <Skeleton width="90%" height="20px" />
    <Skeleton width="95%" height="20px" />
    <Skeleton width="85%" height="20px" />
    <div style={{ marginTop: 'var(--pf-v5-global--spacer--lg)' }}>
      <Skeleton width="40%" height="24px" />
      <br />
      <Skeleton width="100%" height="80px" />
    </div>
    <div style={{ marginTop: 'var(--pf-v5-global--spacer--lg)' }}>
      <Skeleton width="35%" height="24px" />
      <br />
      <Skeleton width="100%" height="60px" />
    </div>
  </Flex>
);

const OverviewTab: React.FC<OverviewTabProps> = ({
  learningPath,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  if (isLoading || !learningPath) {
    return <OverviewTabSkeleton />;
  }

  const progressPercent = Math.round((learningPath.user_progress ?? 0) * 100);
  const hasDescription = !!learningPath.description?.body;
  const hasPrerequisites = !!learningPath.prerequisites?.body;

  return (
    <>
      <LandingLayout.Progress>
        {t('Progress: {{progress}}%', { progress: progressPercent })}
      </LandingLayout.Progress>

      {hasDescription && (
        // eslint-disable-next-line react/no-danger
        <section
          className="skills-path-overview__collateral"
          dangerouslySetInnerHTML={{
            __html: `<b>${t('Introduction')}:</b>&nbsp;${
              learningPath.description.body
            }`,
          }}
        />
      )}

      {/* eslint-disable-next-line react/no-danger */}
      <section
        className="skills-path-overview__collateral"
        dangerouslySetInnerHTML={{
          __html: `<b>${t('Prerequisites')}:</b>&nbsp;${
            hasPrerequisites ? learningPath.prerequisites.body : t('None')
          }`,
        }}
      />
    </>
  );
};

export default OverviewTab;
